// token 失效需要登录
export const TOKEN_EXPIRATION = [499]

// 不全局提示
export const NOT_SHOW_MSG = []
